import { render } from "./pengYouQuanPage.vue?vue&type=template&id=db0e0e7e&scoped=true"
import script from "./pengYouQuanPage.vue?vue&type=script&lang=js"
export * from "./pengYouQuanPage.vue?vue&type=script&lang=js"

import "./pengYouQuanPage.vue?vue&type=style&index=0&id=db0e0e7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0e0e7e"]])

export default __exports__